<template>
  <div v-if="params.value">
    <div class="image-text-cell">
      <img
        :src="getImageName('austria')"
        v-if="params.value && params.value.toLowerCase() == 'austria'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('denmark')"
        v-if="params.value && params.value.toLowerCase() == 'denmark'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('france')"
        v-if="params.value && params.value.toLowerCase() == 'france'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('germany')"
        v-if="params.value && params.value.toLowerCase() == 'germany'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('hungary')"
        v-if="params.value && params.value.toLowerCase() == 'hungary'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('italy')"
        v-if="params.value && params.value.toLowerCase() == 'italy'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('kazakhstan')"
        v-if="params.value && params.value.toLowerCase() == 'kazakhstan'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('norway')"
        v-if="params.value && params.value.toLowerCase() == 'norway'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('poland')"
        v-if="params.value && params.value.toLowerCase() == 'poland'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('spain')"
        v-if="params.value && params.value.toLowerCase() == 'spain'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('sweden')"
        v-if="params.value && params.value.toLowerCase() == 'sweden'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('switzerland')"
        v-if="params.value && params.value.toLowerCase() == 'switzerland'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('united_kingdom')"
        v-if="params.value && params.value.toLowerCase() == 'united_kingdom'"
        alt="Image"
        class="cell-image"
      />
      <img
        :src="getImageName('china')"
        v-if="params.value && params.value.toLowerCase() == 'china'"
        alt="Image"
        class="cell-image"
      />

      <span v-if="params.value && params.value.toLowerCase() == 'austria'"
        >AT</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'denmark'"
        >DK</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'france'"
        >FR</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'germany'"
        >DE</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'hungary'"
        >HU</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'italy'"
        >IT</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'kazakhstan'"
        >KZ</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'norway'"
        >NO</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'poland'"
        >PL</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'spain'"
        >ES</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'sweden'"
        >SE</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'switzerland'"
        >CH</span
      >
      <span
        v-if="params.value && params.value.toLowerCase() == 'united_kingdom'"
        >GB</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'nordic'"
        >NORD</span
      >
      <span v-if="params.value && params.value.toLowerCase() == 'china'"
        >CN</span
      >
    </div>
    <div>
      {{ params.editorName }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params: null,
      countries: [],
    };
  },
  mounted() {
    //this.fetchCountries();
  },
  methods: {
    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },
    capitalizeWithUnderscore(string) {
      if (!string) return "";
      return string
        .split("_") // Split by underscore
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ) // Capitalize first letter of each word
        .join("_"); // Join back with underscore
    },
    getImageName(country) {
      return "/files/flags/" + this.capitalizeWithUnderscore(country) + ".png";
    },
  },
};
</script>

<style>
.image-text-cell {
  display: flex;
  align-items: center;
}
.cell-image {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
</style>
